App.namespace.wrap('components.send_enquiry', (options) => {
  const send = (data, callback, captchaCallback) => {
    $.ajax({
      url: options.endpoint,
      data,
      method: 'POST',
      dataType: 'json',
      success(response) {
        callback(null, response);
      },
      error(response) {
        if (response.status === 403) {
          captchaCallback();
          Rollbar.debug('Captcha requested');
          return;
        }

        callback(true, response);

        if (response.status !== 200 && response.status !== 0) {
          Rollbar.critical('Failed to send enquiry. Server Error');
        }
      },
    });
    Rollbar.info('Enquiry sent');
  };

  return {
    send,
  };
});
